<template>
  <div>
    <Alert v-bind="alertprops"/>
    <v-data-table
      :headers="headers"
      :items="propertyData"
      sort-by="name"
      class="elevation-1"
    >
      <template v-slot:top>
        <v-toolbar
          flat
        >
          <v-toolbar-title>{{propertyType}} Data</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-dialog
            v-model="dialog"
            max-width="500px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                color="green"
                dark
                class="mb-2"
                v-bind="attrs"
                v-on="on"
              >
                New {{propertyType}}
              </v-btn>
            </template>
            <v-card>
              <v-card-title>
                <span class="headline">{{ formTitle }}</span>
              </v-card-title>

              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col
                      cols="12"
                      
                    >
                      <v-text-field
                        v-model="editedItem.name"
                        :label="`${propertyType} name`"
                      ></v-text-field>
                    </v-col>
                    <v-col
                      cols="12"
                    >
                      <v-textarea
                        v-model="editedItem.desc"
                        :label="`${propertyType} Detail`"
                      ></v-textarea>
                    </v-col>
                    <v-col
                      cols="12"
                      sm="6"
                      md="4"
                    >
                    <CloudinaryButton :folder="`/properties/${propertyType}`"/>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  color="blue darken-1"
                  text
                  @click="close"
                >
                  Cancel
                </v-btn>
                <v-btn
                  color="blue darken-1"
                  text
                  @click="save"
                >
                  Save
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-dialog v-model="dialogDelete" max-width="500px">
            <v-card>
              <v-card-title class="headline">Are you sure you want to delete this item?</v-card-title>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="closeDelete">Cancel</v-btn>
                <v-btn color="blue darken-1" text @click="deleteItemConfirm">OK</v-btn>
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-toolbar>
      </template>
      <template v-slot:item.img="{ item }">
            <img :src="item.img_url" :alt="item.name" style="width: 160px; height: 120px;" />
        </template>
      <template v-slot:item.actions="{ item }">
        <v-icon
          medium
          class="mr-2"
          color="blue"
          @click="editItem(item)"
        >
          mdi-pencil
        </v-icon>
        <v-icon
          medium
          color="red"
          @click="deleteItem(item)"
        >
          mdi-delete
        </v-icon>
      </template>
    </v-data-table>
  </div>
</template>

<script>
  import { mapActions, mapGetters, mapMutations } from 'vuex'
  import Alert from '../../components/Alert'
  import CloudinaryButton from '../../components/CloudinaryUpload'
  import PropertyDataService from '../../services/PropertyDataService'

  export default {
    name: "Company",
    components: {
      CloudinaryButton,
      Alert
    },
    data: () => ({
      dialog: false,
      dialogDelete: false,
      headers: [
        {
          text: 'Property',
          align: 'start',
          sortable: true,
          value: 'name',
        },
        { text: 'Description', value: 'desc', sortable: false, },
        { text: 'Image', value: 'img', sortable: false, },
        { text: 'Actions', value: 'actions', sortable: false },
      ],
      propertyType: '',
      propertyData: [],
      editedIndex: -1,
      editedItem: {
        name: '',
        desc: '',
        img_url: '',
        img_id: ''
      },
      defaultItem: {
        name: '',
        desc: '',
        img_url: '',
        img_id: ''
      },
      alertprops: {
        alertType: '',
        content: '',
        alert: false
      }
    }),

    computed: {
      formTitle () {
        return this.editedIndex === -1 ? `New ${this.propertyType}` : `Edit ${this.propertyType}`
      },
      ...mapGetters(['img_id', 'img_url'])
    },

    watch: {
      dialog (val) {
        val || this.close()
      },
      dialogDelete (val) {
        val || this.closeDelete()
      },
    },

    created () {
      this.propertyType = this.$route.params.name[0].toUpperCase() + this.$route.params.name.slice(1)
      this.initialize()
    },

    updated() {
      setTimeout(()=>{
        this.alertprops.alert = false
      },2000)
    },

    methods: {
      ...mapActions(['logout']),
      ...mapMutations(['resetImg']),
      
      initialize () {
        PropertyDataService.read(this.propertyType)
        .then(property => {
          this.propertyData = property.data[0].properties
        })
        .catch(err => {
            this.getAlertData("error", err.response.data.message, true)
        })
      },

      editItem (item) {
        this.editedIndex = this.propertyData.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialog = true
      },

      deleteItem (item) {
        this.editedIndex = this.propertyData.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialogDelete = true
      },

      deleteItemConfirm () {
        PropertyDataService.delete(this.propertyType ,this.propertyData[this.editedIndex].name)
        .then(res => {
          this.getAlertData("success", res.data.message, true)
          this.initialize()
          this.closeDelete()
        })
        .catch(err => {
          this.getAlertData("error", err.response.data.message, true)
          this.checkAuth(err)
        })
      },

      close () {
        this.dialog = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      closeDelete () {
        this.dialogDelete = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      save () {
        if (this.editedIndex > -1) {
          const updatedData = {
            img_id: this.img_id ? this.img_id : this.editedItem.img_id,
            img_url: this.img_url ? this.img_url : this.editedItem.img_url,
            desc: this.editedItem.desc,
            name: this.editedItem.name
          }
          PropertyDataService.update(this.propertyType, this.propertyData[this.editedIndex]._id, updatedData)
          .then(res => {
            this.getAlertData("success", res.data.message, true)
            this.resetImg() //reset img_id and img_url to ''
            this.initialize()
          })
          .catch(err => {
            this.getAlertData("error", err.response.data.message, true)
            this.checkAuth(err)
          })
        } else {
          const data = {
            img_id: this.img_id,
            img_url: this.img_url,
            desc: this.editedItem.desc,
            name: this.editedItem.name,
          }
          PropertyDataService.create(data, this.propertyType)
          .then(res => {
            this.getAlertData("success", res.data.message, true)
            this.resetImg() //reset img_id and img_url to ''
            this.initialize()
          })
          .catch(err => {
            this.getAlertData("error", err.response.data.message, true)
            this.checkAuth(err)
          })
        }
        this.close()
      },

      getAlertData(type, content, alert) {
        this.alertprops.alertType = type,
        this.alertprops.content = content,
        this.alertprops.alert = alert
      },

      checkAuth(err){
        if(err.response.status == 403){
          setTimeout(()=>{
            this.logout()
          },2000)
        }
      }
    },
  }
</script>